import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import ModalPortal from "../../../community/potal";

import {
  toggleLikedComment,
  toggleLikedRecomment,
} from "redux/modules/postSlice";

import { Background } from "../FeedStyle";

//import LikeToggleRecomment from "../../../community/common/LikeToggleRecomment/index";
//import LikeToggleComment from "../../../community/common/LikeToggleComment/index";

function MyCommentsRender({ comment }) {
  const dispatch = useDispatch();

  const PostIsDeleted = comment.isDeleteFeed;
  // true OR false 나옴> true면 삭제된게시글이라고 표시,
  // false나오면 게시글 내용 한줄로 나오게 표시

  const [modal, setModal] = useState(false); // 게시글 삭제됨 알림 모달
  const replaceNumber = Number(comment.likeCount.replace(/(^0+)/, ""));
  const [likeCount, setLikeCount] = useState(replaceNumber);
  // const replaceNumber = Number(comment.likeCount.replace(/(^0+)/, ""));
  // const [likeCount, setLikeCount] = useState(replaceNumber);
  const [isLiked, setIsLiked] = useState(comment.isLiked);

  const onClickDeletedPost = useCallback(() => {
    setModal(true);

    setTimeout(() => {
      setModal(false);
    }, 700);
  }, []);

  // 좋아요 대댓글
  const onClickRecomToggleUnLiked = useCallback(() => {
    setIsLiked(false);
    setLikeCount((prev) => prev - 1);

    dispatch(toggleLikedRecomment(comment.recommentId));
  }, [dispatch, comment.recommentId]);
  const onClickRecomToggleLiked = useCallback(() => {
    setIsLiked(true);
    setLikeCount((prev) => prev + 1);

    dispatch(toggleLikedRecomment(comment.recommentId));
  }, [dispatch, comment.recommentId]);
  // 좋아요 댓글
  const onClickToggleUnLiked = useCallback(() => {
    setIsLiked(false);
    setLikeCount((prev) => prev - 1);

    dispatch(toggleLikedComment(comment.commentId));
  }, [dispatch, comment.commentId]);
  const onClickToggleLiked = useCallback(() => {
    setIsLiked(true);
    setLikeCount((prev) => prev + 1);

    dispatch(toggleLikedComment(comment.commentId));
  }, [dispatch, comment.commentId]);

  return (
    <>
      <div className="myComments">
        {/* 본문 */}
        {!PostIsDeleted ? ( // 해당 댓/답글의 게시물이 존재하는 경우
          <Link to={`/boards/${comment.boardId}`} key={comment.boardId}>
            <div className="postContent">
              {/* 게시물의 content추가되면 아래코드 두줄 'comment.게시물content' 로 바꾸기 */}
              {comment.boardContent.substr(0, 29)}
              {comment.boardContent.length > 29 && "..."}
            </div>
          </Link>
        ) : (
          // 해당 댓/답글의 게시물이 삭제된 경우
          <>
            <div className="deletedPost" onClick={onClickDeletedPost}>
              삭제된 게시글입니다.
            </div>
            {modal && (
              <ModalPortal>
                <Background>
                  <div>
                    <div>삭제된 게시글입니다</div>
                  </div>
                </Background>
              </ModalPortal>
            )}
          </>
        )}

        {/* 댓글/대댓글 */}
        <div className="commentContent">
          {comment.content.substr(0, 51)}
          {comment.content.length > 51 && "..."}
        </div>

        {/* footer */}
        <div className="aside">
          <div className="like">
            {comment.recommentId
              ? console.log("대댓", comment.recommentId, "포스트", comment)
              : console.log("댓", comment.commentId, comment)}
            {comment.recommentId ? (
              // 대댓글
              isLiked ? (
                <img
                  src="/img/likedFull.svg"
                  alt="좋아요"
                  //className={`${comment.isliked}`}
                  onClick={
                    !PostIsDeleted
                      ? onClickRecomToggleUnLiked
                      : onClickDeletedPost
                  }
                />
              ) : (
                <img
                  src="/img/liked.svg"
                  alt="좋아요"
                  //className={`${comment.isliked}`}
                  onClick={
                    !PostIsDeleted
                      ? onClickRecomToggleLiked
                      : onClickDeletedPost
                  }
                />
              )
            ) : // 댓글
            isLiked ? (
              <img
                src="/img/likedFull.svg"
                alt="좋아요"
                className={`${comment.isliked}`}
                onClick={
                  !PostIsDeleted ? onClickToggleUnLiked : onClickDeletedPost
                }
              />
            ) : (
              <img
                src="/img/liked.svg"
                alt="좋아요"
                className={`${comment.isliked}`}
                onClick={
                  !PostIsDeleted ? onClickToggleLiked : onClickDeletedPost
                }
              />
            )}

            <div className={isLiked ? "orange" : "black"}>
              <div className="likeText">좋아요</div>
              <div>{likeCount}</div>
            </div>
          </div>

          <div className="createdAt">{comment.createdAt}</div>
        </div>
      </div>
      <div className="boldLine"></div>
    </>
  );
}

export default MyCommentsRender;
